import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
const NoMatches = _ref => {
  let {
    noMatchesFound,
    placeholder
  } = _ref;
  if (noMatchesFound) {
    return /*#__PURE__*/_jsx("div", {
      className: "px-2.5 py-1 leading-7 text-sm",
      children: /*#__PURE__*/_jsx("span", {
        children: placeholder
      })
    });
  }
  return null;
};
NoMatches.propTypes = {
  noMatchesFound: PropTypes.bool.isRequired,
  placeholder: PropTypes.string.isRequired
};
export default NoMatches;
//# sourceMappingURL=NoMatches.js.map